import { useEffect } from "react";
import { usePageViewTracker } from "@/hooks/usePageViewTracker";
import { useDeviceDiagnostics } from "@/hooks/useDeviceDiagnostics";
import { flushNativeWebViewTerminations } from "@/lib/webviewTerminationDiagnostics";

/**
 * Invisible component that logs page views for session tracking and records
 * the signed-in user's device/app version for Super Admin diagnostics.
 */
export function PageViewTracker() {
  usePageViewTracker();
  useDeviceDiagnostics();
  // Observability only: forward native WKWebView termination records (iOS).
  useEffect(() => {
    void flushNativeWebViewTerminations();
  }, []);
  return null;
}
